'use client';

import { Option } from '@app/types/data-table';
import type { Column } from '@tanstack/react-table';
import * as React from 'react';
import { FacetedFilter } from './faceted-filter';

interface DataTableFacetedFilterProps<TData, TValue> {
  column?: Column<TData, TValue>;
  title?: string;
  options: Option[];
  multiple?: boolean;
}

export function DataTableFacetedFilter<TData, TValue>({
  column,
  title,
  options,
  multiple,
}: DataTableFacetedFilterProps<TData, TValue>) {
  const columnFilterValue = column?.getFilterValue();
  const selectedValues = React.useMemo(
    () =>
      Array.isArray(columnFilterValue) ? (columnFilterValue as string[]) : [],
    [columnFilterValue]
  );

  const onChange = React.useCallback(
    (values: string[]) => {
      column?.setFilterValue(values.length ? values : undefined);
    },
    [column]
  );

  return (
    <FacetedFilter
      title={title}
      itemName={title?.toLowerCase()}
      options={options}
      selectedValues={selectedValues}
      onChange={onChange}
      multiple={multiple}
    />
  );
}
